// The state of the side preview, shared by the panel and by whatever else opens or closes it (the script's header
// has a "hide the preview" button): open or folded, which tab, and who the test is "as". It is remembered in this
// browser (localStorage; every read and write is guarded, the panel works without it). Until the person chooses,
// `open` follows the page's default: edit pages start open, reading pages folded.
import { ref } from 'vue';

const KEY = 'polaris_preview_panel';
export const TESTING_AS = ['new', 'client', 'lost'];
export const TABS = ['chat', 'voice'];

const read = () => {
  try {
    return JSON.parse(window.localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};
const write = value => {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // no storage: the choice lasts until the page is closed
  }
};

const saved = read();
// null: not chosen yet
const chosenOpen = ref(typeof saved.open === 'boolean' ? saved.open : null);
const tab = ref(TABS.includes(saved.tab) ? saved.tab : 'chat');
const testingAs = ref(
  TESTING_AS.includes(saved.testingAs) ? saved.testingAs : 'new'
);

const persist = () =>
  write({
    open: chosenOpen.value,
    tab: tab.value,
    testingAs: testingAs.value,
  });

export function usePreviewPanel() {
  const isOpen = defaultOpen => chosenOpen.value ?? defaultOpen;
  const setOpen = value => {
    chosenOpen.value = value;
    persist();
  };
  const setTab = value => {
    if (!TABS.includes(value)) return;
    tab.value = value;
    persist();
  };
  const setTestingAs = value => {
    if (!TESTING_AS.includes(value)) return;
    testingAs.value = value;
    persist();
  };
  return { isOpen, setOpen, tab, setTab, testingAs, setTestingAs };
}
